import Ajax from 'global/od/Ajax';

const notifyMeWhenInStockRequest = productCode =>
	Ajax.get(`/ajax/productnotify/select?productCode=${productCode}`);

const notifyMeWhenInStockSuccess = (productCode, email) =>
	Ajax({
		url: `/ajax/productnotify/create?productCode=${productCode}`,
		method: 'POST',
		data: { email },
	});

export { notifyMeWhenInStockRequest as default, notifyMeWhenInStockSuccess };
